import React from 'react';
import { VenueCard } from './VenueCard';
import { Wifi, Utensils, Lightbulb, Users, Car, Music, Wine, Camera, Speaker, Monitor, DoorOpen, LayoutGrid } from 'lucide-react';
export function VenueCards() {
  const venues = [{
    title: 'The Azure Hall',
    subtitle: 'Grand Celebrations & Weddings',
    capacity: 'Up to 300 Guests',
    description: 'Our flagship ballroom featuring soaring ceilings, crystal chandeliers, and a dedicated bridal suite. The perfect canvas for your dream wedding.',
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
    features: [{
      name: 'High-Speed WiFi',
      icon: Wifi
    }, {
      name: 'Full Catering',
      icon: Utensils
    }, {
      name: 'Custom Lighting',
      icon: Lightbulb
    }, {
      name: 'Bridal Suite',
      icon: Users
    }, {
      name: 'Valet Parking',
      icon: Car
    }]
  }, {
    title: 'The Crystal Lounge',
    subtitle: 'Birthdays & Social Events',
    capacity: 'Up to 150 Guests',
    description: 'An intimate yet vibrant space with built-in DJ booth, dynamic lighting, and a full-service bar. Celebrate in style.',
    image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
    features: [{
      name: 'High-Speed WiFi',
      icon: Wifi
    }, {
      name: 'DJ Booth',
      icon: Music
    }, {
      name: 'Bar Service',
      icon: Wine
    }, {
      name: 'Photo Area',
      icon: Camera
    }, {
      name: 'Sound System',
      icon: Speaker
    }]
  }, {
    title: 'The Sapphire Room',
    subtitle: 'Corporate & Private Events',
    capacity: 'Up to 200 Guests',
    description: 'Sophisticated and versatile, equipped with state-of-the-art AV technology and a private entrance. Ideal for galas, fundraisers, and executive retreats.',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    features: [{
      name: 'High-Speed WiFi',
      icon: Wifi
    }, {
      name: 'Full Catering',
      icon: Utensils
    }, {
      name: 'AV Equipment',
      icon: Monitor
    }, {
      name: 'Private Entrance',
      icon: DoorOpen
    }, {
      name: 'Breakout Rooms',
      icon: LayoutGrid
    }]
  }];
  return <section className="py-24 px-6 md:px-12 bg-h2o-900 relative" data-id="element-249">
      <div className="max-w-7xl mx-auto" data-id="element-250">
        <div className="text-center mb-16 md:mb-24" data-id="element-251">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 inline-block relative" data-id="element-252">
            Our Signature Spaces
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-24 h-1 bg-h2o-cyan rounded-full" data-id="element-253" />
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto mt-8" data-id="element-254">
            Each space tells its own story, designed to bring your vision to
            life with unparalleled elegance and functionality.
          </p>
        </div>

        <div className="flex flex-col gap-12 md:gap-16" data-id="element-255">
          {venues.map((venue, index) => <VenueCard key={venue.title} {...venue} index={index} reverse={index % 2 !== 0} data-id="element-256" />)}
        </div>
      </div>
    </section>;
}